export default __webpack_public_path__ + "static/media/tasktype.761d4e52.svg";